import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessSpecialtyManagerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-specialty-manager',
  templateUrl: 'business-specialty-manager.html',
})
export class BusinessSpecialtyManagerPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessSpecialtyManagerPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-specialty-manager/business-specialty-manager.ts